// Wrapping as CommonJS module to avoid clients having to use maze.default:
module.exports = require('./generate-maze.js').default;



// WEBPACK FOOTER //
// ./src/cjs-wrapper.js